import React from 'react'
import classNames from 'classnames'
import Search, { useSearch } from 'src/components/Search'
import { getDepartmentRoutes } from 'src/models/departments'
import NavDropdown from '../NavDropdown'
import NavLink from 'src/components/NavLink'
import { useSiteContext } from 'src/components/AppWrapper'
import { HeaderContainer, MainNav, Logo, NavLinks, PeopleSubMenu, DepartmentsSubMenu } from '../styled'
import { useUserRoles } from 'src/components/Roles'

function NavHeader() {
	const { siteMeta } = useSiteContext()
	const departments = siteMeta.departments
	const { searchOpen } = useSearch()
	const { isAdmin } = useUserRoles()

	return (
		<MainNav>
			<HeaderContainer className={classNames({ ['searchOpen']: !!searchOpen })}>
				<NavLinks>
					<NavLink to="/home" id="logoLink">
						<Logo type="dark" />
					</NavLink>
					{!searchOpen && (
						<>
							<NavDropdown
								title="Departments"
								subMenuStyle={DepartmentsSubMenu}
								content={departments.map((department) => ({
									title: department.title,
									content: getDepartmentRoutes(department, isAdmin),
									to: `/departments/${department.id}/overview`
								}))}
							/>

							<NavLink title="News & Resources" to="/news" primary />

							<NavDropdown
								title="People"
								subMenuStyle={PeopleSubMenu}
								content={[
									{ title: 'Company Directory', to: '/company-directory' },
									{ title: 'Org Chart', to: '/org-chart' }
								]}
							/>

							

							<NavLink title="Discussions" to="/discussions" primary />

							<NavDropdown
								title="Galleries"
								subMenuStyle={PeopleSubMenu}
								content={[
									{ title: 'Photo/Video Gallery', to: '/gallery' },
									{ title: 'Job Site Gallery', to: '/jobsite-videos' }
								]}
							/>

							<NavLink title="Calendar" to="/calendar" primary />

							<NavDropdown
								title="IT Services"
								subMenuStyle={PeopleSubMenu}
								content={[
									{ title: 'IT Help', href: 'https://ithelp.nibbi.com' },
									{ title: 'IT Knowledgebase', href: 'https://ithelp.nibbi.com/a/solutions/categories/31000003643/folders/31000023542' },
								]}
							/>
						</>
					)}
				</NavLinks>
				<Search />
			</HeaderContainer>
		</MainNav>
	)
}

export default NavHeader
